/* buildUnifiedValidationSchema.ts */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { z, ZodTypeAny, ZodObject, ZodEffects } from 'zod'
import { FormFieldConfig } from '@/shared/components/DynamicForm/DynamicForm'

export const buildUnifiedValidationSchema = (
  fields: FormFieldConfig[]
): ZodEffects<ZodObject<Record<string, ZodTypeAny>>> => {
  const shape: Record<string, ZodTypeAny> = {}

  const walk = (list: FormFieldConfig[], parent = ''): void => {
    list.forEach(field => {
      const fullPath = parent ? `${parent}.${field.name}` : field.name

      if (field.type === 'input-group' && field.inputs) {
        walk(field.inputs, fullPath)
        return
      }
      if (field.type === 'step') return

      let schema: ZodTypeAny = field.validation ?? z.any()

      if (
        field.syncFormField &&
        schema instanceof z.ZodObject &&
        !field.required
      ) {
        schema = schema.partial()
      }

      shape[fullPath] = schema
    })
  }

  walk(fields)

  return z.object(shape).transform(data => data)
}
